<template>
    <div class="api-attribute-picker">
        <div class="filter-menu">
            <SupsisButton v-if="selectedMenu.length" ghost small @click="prev">
                <span class="material-icons"> chevron_left </span>
            </SupsisButton>
            <div class="breadcrumb-item" v-for="menu in selectedMenu" :key="menu">
                <span> {{ findAttributeByValue(menu).label }} ✦ </span>
            </div>
        </div>

        <div class="webhook-blocks" v-if="!selectedMenu.length">
            <div class="block-item" v-for="block in webhookBlocks" :key="block.id" @click="selectBlock(block)">
                <span class="material-icons">webhook</span>
                <span class="name">{{ block.name || "Webhook" }}</span>
            </div>
        </div>

        <div class="attribute-list" v-else>
            <div class="attr-select">
                <div
                    class="picker-item"
                    v-for="attr in filterAttributes()"
                    @click="() => select(attr.value)"
                    :key="attr.value"
                >
                    <span class="name">{{ attr.label }}</span>
                    <span class="description" v-if="attr.description">{{ attr.description }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";
import flatDiagram from "../../../utils/flatDiagram";

export default {
    name: "WebhookAttributePicker",
    components: {
        SupsisButton,
    },
    props: {
        onPicked: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            searchText: "",
            attributes: [],
            selectedMenu: [],
            webhookBlocks: [],
            selectedBlock: null,
        };
    },
    computed: {
        ...mapGetters({
            board: "CB/board",
        }),
    },
    methods: {
        listWebhookBlocks() {
            const storyId = this.$route.params.id;
            const board = this.board(storyId);
            const flatted = flatDiagram(board.diagram);
            return flatted.filter((block) => block.type === "API_REQUEST");
        },

        generateAttributesForBlock(block) {
            const blockId = block.id;
            const basePrefix = `block.${blockId}`;

            const attributes = [
                {
                    label: "Success",
                    value: `${basePrefix}.success`,
                    description: "Request başarılı oldu mu?",
                },
                {
                    label: "Status",
                    value: `${basePrefix}.status`,
                    description: "HTTP durum kodu",
                },
                {
                    label: "Status Text",
                    value: `${basePrefix}.statusText`,
                    description: "HTTP durum mesajı",
                },
                {
                    label: "Response Data",
                    value: `${basePrefix}.data`,
                    description: "Yanıt verisi",
                    subAttributes: this.generateDataAttributes(
                        `${basePrefix}.data.$.`,
                        block.payload?.exampleResponseModel?.data
                    ),
                },
                {
                    label: "Error",
                    value: `${basePrefix}.error`,
                    description: "Hata mesajı (varsa)",
                },
            ];

            return attributes;
        },

        generateDataAttributes(prefix, data) {
            const attributes = [];

            if (!data) return;

            //const rootData = Array.isArray(data) ? data[0] : data;
            const rootData = data;

            console.log("generateDataAttributes", { prefix, data, rootData });

            console.log("generateDataAttributes each", {
                data,
                isValueArray: Array.isArray(data),
                isValueObject: typeof data === "object" && data !== null,
                isValuePrimitive: typeof data !== "object" && data !== null,
            });
            if (Array.isArray(rootData) && rootData.length > 0) {
                // Array'in ilk elemanına göre alt özellikler oluştur
                const firstItem = rootData[0];
                attributes.push({
                    label: "*",
                    value: `${prefix}.*`,
                    description: "*",
                });

                Object.entries(firstItem).forEach(([key, value]) => {
                    const _prefix = prefix.includes("$.") ? `${prefix}.${key}` : `${prefix}.${key}`;
                    console.log("generateDataAttributes array each", { key, prefix: _prefix, value });
                    const subAttributes = this.generateDataAttributes(_prefix, value);
                    attributes.push({
                        label: key,
                        value: _prefix,
                        description: key,
                        subAttributes,
                    });
                });
            } else if (typeof rootData === "object" && rootData !== null) {
                attributes.push({
                    label: "*",
                    value: `${prefix}.*`,
                    description: "*",
                });
                Object.entries(rootData).forEach(([key, value]) => {
                    console.log("generateDataAttributes object each", { key, prefix: `${prefix}.${key}`, value });
                    const _prefix = prefix.includes("$.") ? `${prefix}.${key}` : `${prefix}.${key}`;
                    attributes.push({
                        label: key,
                        value: _prefix,
                        description: key,
                        subAttributes: this.generateDataAttributes(_prefix, value),
                    });
                });
            } else {
                console.log("generateDataAttributes else", { prefix });
                return undefined;
            }

            return attributes;
        },

        selectBlock(block) {
            this.selectedBlock = block;
            this.attributes = this.generateAttributesForBlock(block);
            this.selectedMenu.push("root");
        },

        filterAttributes() {
            const parentAttribute = this.getParentAttribute();
            let attrs = parentAttribute ? parentAttribute.subAttributes : this.attributes;

            return attrs.filter((attr) => {
                if (this.searchText) {
                    return (attr.label || "").toLowerCase().includes(this.searchText.toLowerCase());
                }
                return true;
            });
        },

        getParentAttribute() {
            if (this.selectedMenu.length <= 1) return null;
            const attributes = this.getFlatAttributes();
            const parent = this.selectedMenu[this.selectedMenu.length - 1];
            return attributes.find((x) => x.value === parent);
        },

        getFlatAttributes() {
            const flat = (attr) => {
                if (attr.subAttributes) {
                    return [attr, ...attr.subAttributes.flatMap(flat)];
                }
                return [attr];
            };
            return this.attributes.flatMap(flat);
        },

        select(value) {
            const attributes = this.getFlatAttributes();
            const attr = attributes.find((x) => x.value === value);
            if (Array.isArray(attr.subAttributes) && attr.subAttributes.length) {
                this.selectedMenu.push(value);
            } else {
                this.onPicked(value);
            }
        },

        prev() {
            if (this.selectedMenu.length === 1) {
                this.selectedMenu = [];
                this.selectedBlock = null;
            } else {
                this.selectedMenu.pop();
            }
        },

        findAttributeByValue(value) {
            if (value === "root") {
                return { label: this.selectedBlock?.name || "Webhook" };
            }
            const attributes = this.getFlatAttributes();
            return attributes.find((x) => x.value === value);
        },
    },
    created() {
        this.webhookBlocks = this.listWebhookBlocks();
    },
};
</script>

<style lang="scss" scoped>
.api-attribute-picker {
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    max-height: 600px;
    min-height: 200px;
    user-select: none;
    width: 100%;
    padding: 5px;

    .filter-menu {
        display: flex;
        align-items: center;
        gap: 3px;
        margin-bottom: 10px;

        .supsis-button {
            border: none !important;
            font-size: 13px;
            height: 25px;
        }

        .breadcrumb-item {
            display: flex;
        }
    }

    .webhook-blocks {
        .block-item {
            display: flex;
            align-items: center;
            padding: 8px;
            cursor: pointer;
            border-radius: 4px;
            margin-bottom: 4px;

            &:hover {
                background-color: #f0f4f7;
            }

            .material-icons {
                margin-right: 8px;
                color: #647283;
            }

            .name {
                color: #22272d;
                font-size: 14px;
            }
        }
    }

    .attribute-list {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 5px;
        margin: 0px 5px 0px 5px;

        .picker-item {
            align-items: center;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            padding: 8px;
            transition: background-color 0.2s;
            border-radius: 4px;

            &:hover {
                background-color: #f0f4f7;
            }

            .name {
                color: #22272d;
                font-size: 14px;
            }

            .description {
                color: #9ba6b3;
                font-size: 12px;
            }
        }
    }
}
</style>
